// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionLegend-module--root--3Ig6I","light":"SectionLegend-module--light--3T37I","decorator":"SectionLegend-module--decorator--2GPfF"};